import { defineMessages } from "react-intl";

const messages = defineMessages({
  "ui.address.autoCompleteAddress.placeholder": {
    id: "ui.address.autoCompleteAddress.placeholder",
    defaultMessage: "Type to search",
    description: "Placeholder text for Auto Complete Address input",
  },
  "ui.address.findMe.tooltip": {
    id: "ui.address.findMe.tooltip",
    defaultMessage: "Find my location",
    description: "Find my location button in a Auto Complete Address input",
  },
  "ui.autoComplete.address.manualButton": {
    id: "ui.autoComplete.address.manualButton",
    defaultMessage: "Enter address manually",
    description: "Manual Address Button",
  },
  "ui.autoComplete.address.noResult": {
    id: "ui.autoComplete.address.noResult",
    defaultMessage: "No results",
    description: "No results label",
  },
  "ui.avatar.tooltip.open": {
    id: "ui.avatar.tooltip.open",
    defaultMessage: "Open {name}",
    description: "Open user/team tooltip message",
  },
  "ui.avatar.userDisplayNameWithInfo": {
    id: "ui.avatar.userDisplayNameWithInfo",
    defaultMessage:
      "{username}{isDeleted, select, true { (Deleted)} other {}}{isDeactivated, select, true { (Deactivated)} other {}}",
    description: "Full username with meta-info about its delete or deactivated status",
  },
  "ui.calendar.header.date.format": {
    id: "ui.calendar.header.date.format",
    defaultMessage: "MMM yyyy",
    description: "Calendar header date format",
  },
  "ui.colorComponents.changeColor": {
    id: "ui.colorComponents.changeColor",
    defaultMessage: "Change Color",
    description: "Change Color message in a ColorComponent",
  },
  "ui.common.teamItem.noTeam": {
    id: "ui.common.teamItem.noTeam",
    defaultMessage: "No Team",
    description: "No Team item label in the User Menu",
  },
  "ui.common.teamItem.owners": {
    id: "ui.common.teamItem.owners",
    defaultMessage: "Owners",
    description: "Owners item label in the User Menu",
  },
  "ui.editableText.cancel.tooltip": {
    id: "ui.editableText.cancel.tooltip",
    defaultMessage: "Cancel",
    description: "Tooltip of the cancel button in EditableText field",
  },
  "ui.editableText.save.tooltip": {
    id: "ui.editableText.save.tooltip",
    defaultMessage: "Save",
    description: "Tooltip of the save button in EditableText field",
  },
  "ui.editableText.save.tooltip.error.required": {
    id: "ui.editableText.save.tooltip.error.required",
    defaultMessage: "Non-empty value is required",
    description:
      "Tooltip of the save button in EditableText field when non-empty value is required",
  },
  "ui.editableText.tooltip": {
    id: "ui.editableText.tooltip",
    defaultMessage: "Edit",
    description: "Tooltip for the EditableText field",
  },
  "ui.emailBody.actions.attachFiles": {
    id: "ui.emailBody.actions.attachFiles",
    defaultMessage: "Attach files",
  },
  "ui.emailBody.actions.attachTitle": {
    id: "ui.emailBody.actions.attachTitle",
    defaultMessage: "Attach a new file or an existing resource?",
  },
  "ui.emailBody.actions.dynamicVariables.noResult.subTitle": {
    id: "ui.emailBody.actions.dynamicVariables.noResult.subTitle",
    defaultMessage: "There are no dynamic variables that match this search.",
  },
  "ui.emailBody.actions.dynamicVariables.noResult.title": {
    id: "ui.emailBody.actions.dynamicVariables.noResult.title",
    defaultMessage: "No results",
  },
  "ui.emailBody.actions.dynamicVariables.searchPlaceholder": {
    id: "ui.emailBody.actions.dynamicVariables.searchPlaceholder",
    defaultMessage: "Search dynamic variables",
  },
  "ui.emailBody.actions.dynamicVariables.someEntityDontHaveValue": {
    id: "ui.emailBody.actions.dynamicVariables.someEntityDontHaveValue",
    defaultMessage: "One or more recipient does not have a value for this dynamic variable",
  },
  "ui.emailBody.actions.filesAttach.largeFilesWarning.description": {
    id: "ui.emailBody.actions.filesAttach.largeFilesWarning.description",
    defaultMessage:
      "The size of your attempted upload exceeds 24 MB. Please compress the file and try again.",
    description: "Email attach files large files warning description",
  },
  "ui.emailBody.actions.filesAttach.largeFilesWarning.title": {
    id: "ui.emailBody.actions.filesAttach.largeFilesWarning.title",
    defaultMessage: "Attachment size limit exceeded",
    description: "Email attach files large files warning title",
  },
  "ui.emailBody.actions.formatting": {
    id: "ui.emailBody.actions.formatting",
    defaultMessage: "Formatting options",
  },
  "ui.emailBody.actions.generateEmail": {
    id: "ui.emailBody.actions.generateEmail",
    defaultMessage: "AI Writer",
  },
  "ui.emailBody.actions.insertDynamicVar": {
    id: "ui.emailBody.actions.insertDynamicVar",
    defaultMessage: "Insert dynamic variable",
  },
  "ui.emailBody.actions.insertLink": {
    id: "ui.emailBody.actions.insertLink",
    defaultMessage: "Insert link",
    description: "Insert Link button text",
  },
  "ui.emailBody.actions.insertResourceLink": {
    id: "ui.emailBody.actions.insertResourceLink",
    defaultMessage: "Insert resource link",
  },
  "ui.emailBody.actions.preview": {
    id: "ui.emailBody.actions.preview",
    defaultMessage: "Preview",
  },
  "ui.emailBody.attachedFileList.download": {
    id: "ui.emailBody.attachedFileList.download",
    defaultMessage: "Download",
    description: "Email attached file download label",
  },
  "ui.emailBody.attachedFileList.fileSize": {
    id: "ui.emailBody.attachedFileList.fileSize",
    defaultMessage: "{size, number, ::K}MB",
  },
  "ui.emailBody.attachedFileList.remove": {
    id: "ui.emailBody.attachedFileList.remove",
    defaultMessage: "Remove attachment",
    description: "Email attached file remove label",
  },
  "ui.emailBody.emailUnsubscribeLink.checkboxLabel": {
    id: "ui.emailBody.emailUnsubscribeLink.checkboxLabel",
    defaultMessage: "Add unsubscribe link to email footer",
    description: "Email unsubscribe link checkbox label",
  },
  "ui.emailBody.emailUnsubscribeLink.checkboxTooltip": {
    id: "ui.emailBody.emailUnsubscribeLink.checkboxTooltip",
    defaultMessage:
      "Email laws require an unsubscribe link for all bulk emails sent for commercial purposes. If this bulk email is being sent for relationship or transactional purposes, it is not required. If a recipient unsubscribes, they will be automatically excluded from all emails when this box is checked.",
    description: "Email unsubscribe link checkbox checkbox tooltip",
  },
  "ui.emailBody.emailUnsubscribeLink.linkLabel": {
    id: "ui.emailBody.emailUnsubscribeLink.linkLabel",
    defaultMessage: "Unsubscribe",
    description: "Email unsubscribe link checkbox link label",
  },
  "ui.emailBody.imageModal.addLink": {
    id: "ui.emailBody.imageModal.addLink",
    defaultMessage: "Add Link",
    description: "Email image remove add link label",
  },
  "ui.emailBody.imageModal.altTextDescription": {
    id: "ui.emailBody.imageModal.altTextDescription",
    defaultMessage:
      "Alt text is a brief image description that helps visually impaired users via screen readers and appears if images don't load.",
    description: "Email image alt description",
  },
  "ui.emailBody.imageModal.altTextTitle": {
    id: "ui.emailBody.imageModal.altTextTitle",
    defaultMessage: "Alt Text",
    description: "Email image alt text title",
  },
  "ui.emailBody.imageModal.change": {
    id: "ui.emailBody.imageModal.change",
    defaultMessage: "Change",
    description: "Email image change label",
  },
  "ui.emailBody.imageModal.description": {
    id: "ui.emailBody.imageModal.description",
    defaultMessage: "Description",
    description: "Email image description label",
  },
  "ui.emailBody.imageModal.editAltText": {
    id: "ui.emailBody.imageModal.editAltText",
    defaultMessage: "Edit alt text",
    description: "Email image edit alt text label",
  },
  "ui.emailBody.imageModal.goToLink": {
    id: "ui.emailBody.imageModal.goToLink",
    defaultMessage: "Go to link:",
    description: "Email image got to link label",
  },
  "ui.emailBody.imageModal.linkTitle": {
    id: "ui.emailBody.imageModal.linkTitle",
    defaultMessage: "Link",
    description: "Email image link title",
  },
  "ui.emailBody.imageModal.ok": {
    id: "ui.emailBody.imageModal.ok",
    defaultMessage: "Okay",
    description: "Email image modal ok",
  },
  "ui.emailBody.imageModal.remove": {
    id: "ui.emailBody.imageModal.remove",
    defaultMessage: "Remove",
    description: "Email image remove action label",
  },
  "ui.emailBody.imageModal.size.bestFit": {
    id: "ui.emailBody.imageModal.size.bestFit",
    defaultMessage: "Best Fit",
    description: "Email image best fit action label",
  },
  "ui.emailBody.imageModal.size.original": {
    id: "ui.emailBody.imageModal.size.original",
    defaultMessage: "Original Size",
    description: "Email image original size action label",
  },
  "ui.emailBody.imageModal.size.small": {
    id: "ui.emailBody.imageModal.size.small",
    defaultMessage: "Small",
    description: "Email image small size action label",
  },
  "ui.emailBody.linkModal.change": {
    id: "ui.emailBody.linkModal.change",
    defaultMessage: "Change",
  },
  "ui.emailBody.linkModal.goToLink": {
    id: "ui.emailBody.linkModal.goToLink",
    defaultMessage: "Go to link:",
  },
  "ui.emailBody.linkModal.insertLink": {
    id: "ui.emailBody.linkModal.insertLink",
    defaultMessage: "Insert Link",
  },
  "ui.emailBody.linkModal.linkText": {
    id: "ui.emailBody.linkModal.linkText",
    defaultMessage: "Link Text",
  },
  "ui.emailBody.linkModal.okay": { id: "ui.emailBody.linkModal.okay", defaultMessage: "Okay" },
  "ui.emailBody.linkModal.remove": {
    id: "ui.emailBody.linkModal.remove",
    defaultMessage: "Remove",
  },
  "ui.emailBody.linkModal.title": {
    id: "ui.emailBody.linkModal.title",
    defaultMessage: "Insert Link",
  },
  "ui.emailBody.resourceLink.downloadLinkText": {
    id: "ui.emailBody.resourceLink.downloadLinkText",
    defaultMessage: "Download",
  },
  "ui.emailBody.resourceLink.downloadTooltip": {
    id: "ui.emailBody.resourceLink.downloadTooltip",
    defaultMessage: "Download resource link",
  },
  "ui.emailBody.resourceLink.notFound": {
    id: "ui.emailBody.resourceLink.notFoun",
    defaultMessage: "Not Found",
  },
  "ui.emailBody.resourceLink.removeTooltip": {
    id: "ui.emailBody.resourceLink.removeTooltip",
    defaultMessage: "Remove resource link",
  },
  "ui.emailBody.resourceLink.restricted": {
    id: "ui.emailBody.resourceLink.restricted",
    defaultMessage: "Restricted",
  },
  "ui.emailBody.toolbar.align": {
    id: "ui.emailBody.toolbar.align",
    defaultMessage: "Align",
    description: "Toolbar align button",
  },
  "ui.emailBody.toolbar.align.center.mac": {
    id: "ui.emailBody.toolbar.align.center.mac",
    defaultMessage: "Align Center (⌘⇧C)",
    description: "Toolbar align center button on Mac",
  },
  "ui.emailBody.toolbar.align.center.win": {
    id: "ui.emailBody.toolbar.align.center.win",
    defaultMessage: "Align Center (Ctrl+Shift+C)",
    description: "Toolbar align center button on Windows",
  },
  "ui.emailBody.toolbar.align.justify.mac": {
    id: "ui.emailBody.toolbar.align.justify.mac",
    defaultMessage: "Align Justify (⌘⇧J)",
    description: "Toolbar align justify button on Mac",
  },
  "ui.emailBody.toolbar.align.justify.win": {
    id: "ui.emailBody.toolbar.align.justify.win",
    defaultMessage: "Align Justify (Ctrl+Shift+J)",
    description: "Toolbar align justify button on Windows",
  },
  "ui.emailBody.toolbar.align.left.mac": {
    id: "ui.emailBody.toolbar.align.left.mac",
    defaultMessage: "Align left (⌘⇧L)",
    description: "Toolbar align left button on Mac",
  },
  "ui.emailBody.toolbar.align.left.win": {
    id: "ui.emailBody.toolbar.align.left.win",
    defaultMessage: "Align left (Ctrl+Shift+L)",
    description: "Toolbar align left button on Windows",
  },
  "ui.emailBody.toolbar.align.right.mac": {
    id: "ui.emailBody.toolbar.align.right.mac",
    defaultMessage: "Align Right (⌘⇧R)",
    description: "Toolbar align right button on Mac",
  },
  "ui.emailBody.toolbar.align.right.win": {
    id: "ui.emailBody.toolbar.align.right.win",
    defaultMessage: "Align Right (Ctrl+Shift+R)",
    description: "Toolbar align right button on Windows",
  },
  "ui.emailBody.toolbar.bold.mac": {
    id: "ui.emailBody.toolbar.bold.mac",
    defaultMessage: "Bold (⌘B)",
    description: "Toolbar bold button on Mac",
  },
  "ui.emailBody.toolbar.bold.win": {
    id: "ui.emailBody.toolbar.bold.win",
    defaultMessage: "Bold (Ctrl+B)",
    description: "Toolbar bold button on Windows",
  },
  "ui.emailBody.toolbar.bulleted.mac": {
    id: "ui.emailBody.toolbar.bulleted.mac",
    defaultMessage: "Bulleted (⌘⇧8)",
    description: "Toolbar bulleted list button on Mac",
  },
  "ui.emailBody.toolbar.bulleted.win": {
    id: "ui.emailBody.toolbar.bulleted.win",
    defaultMessage: "Bulleted (Ctrl+Shift+8)",
    description: "Toolbar bulleted list button on Windows",
  },
  "ui.emailBody.toolbar.image.mac": {
    id: "ui.emailBody.toolbar.image.mac",
    defaultMessage: "Insert Image (⌘⇧I)",
    description: "Toolbar insert image button on Mac",
  },
  "ui.emailBody.toolbar.image.win": {
    id: "ui.emailBody.toolbar.image.win",
    defaultMessage: "Insert Image (Ctrl+Shift+I)",
    description: "Toolbar insert image button on Windows",
  },
  "ui.emailBody.toolbar.indentLess.mac": {
    id: "ui.emailBody.toolbar.indentLess.mac",
    defaultMessage: "Indent less (⌘[)",
    description: "Toolbar indent less button on Mac",
  },
  "ui.emailBody.toolbar.indentLess.win": {
    id: "ui.emailBody.toolbar.indentLess.win",
    defaultMessage: "Indent less (Ctrl+[)",
    description: "Toolbar indent less button on Windows",
  },
  "ui.emailBody.toolbar.indentMore.mac": {
    id: "ui.emailBody.toolbar.indentMore.mac",
    defaultMessage: "Indent more (⌘])",
    description: "Toolbar indent more button on Mac",
  },
  "ui.emailBody.toolbar.indentMore.win": {
    id: "ui.emailBody.toolbar.indentMore.win",
    defaultMessage: "Indent more (Ctrl+])",
    description: "Toolbar indent more button on Windows",
  },
  "ui.emailBody.toolbar.italic.mac": {
    id: "ui.emailBody.toolbar.italic.mac",
    defaultMessage: "Italic (⌘I)",
    description: "Toolbar italic button on Mac",
  },
  "ui.emailBody.toolbar.italic.win": {
    id: "ui.emailBody.toolbar.italic.win",
    defaultMessage: "Italic (Ctrl+I)",
    description: "Toolbar italic button on Windows",
  },
  "ui.emailBody.toolbar.large": {
    id: "ui.emailBody.toolbar.large",
    defaultMessage: "Large",
    description: "Toolbar large font size option",
  },
  "ui.emailBody.toolbar.medium": {
    id: "ui.emailBody.toolbar.medium",
    defaultMessage: "Medium",
    description: "Toolbar medium font size option",
  },
  "ui.emailBody.toolbar.numbered.mac": {
    id: "ui.emailBody.toolbar.numbered.mac",
    defaultMessage: "Numbered (⌘⇧7)",
    description: "Toolbar numbered list button on Mac",
  },
  "ui.emailBody.toolbar.numbered.win": {
    id: "ui.emailBody.toolbar.numbered.win",
    defaultMessage: "Numbered (Ctrl+Shift+7)",
    description: "Toolbar numbered list button on Windows",
  },
  "ui.emailBody.toolbar.redo.mac": {
    id: "ui.emailBody.toolbar.redo.mac",
    defaultMessage: "Redo (⌘⇧Z)",
    description: "Toolbar redo button on Mac",
  },
  "ui.emailBody.toolbar.redo.win": {
    id: "ui.emailBody.toolbar.redo.win",
    defaultMessage: "Redo (Ctrl+Shift+X)",
    description: "Toolbar redo button on Windows",
  },
  "ui.emailBody.toolbar.removeFormatting.mac": {
    id: "ui.emailBody.toolbar.removeFormatting.mac",
    defaultMessage: "Remove formatting  (⌘\\)",
    description: "Toolbar remove formatting button on Mac",
  },
  "ui.emailBody.toolbar.removeFormatting.win": {
    id: "ui.emailBody.toolbar.removeFormatting.win",
    defaultMessage: "Remove formatting  (Ctrl+\\)",
    description: "Toolbar remove formatting button on Windows",
  },
  "ui.emailBody.toolbar.size.mac": {
    id: "ui.emailBody.toolbar.size.mac",
    defaultMessage: "Size (⌘⇧-, ⌘⇧+)",
    description: "Toolbar font size button on Mac",
  },
  "ui.emailBody.toolbar.size.win": {
    id: "ui.emailBody.toolbar.size.win",
    defaultMessage: "Size (Ctrl+Shift+(+), Ctrl+Shift+(-))",
    description: "Toolbar font size button on Windows",
  },
  "ui.emailBody.toolbar.small": {
    id: "ui.emailBody.toolbar.small",
    defaultMessage: "Small",
    description: "Toolbar small font size option",
  },
  "ui.emailBody.toolbar.strikethrough.mac": {
    id: "ui.emailBody.toolbar.strikethrough.mac",
    defaultMessage: "Strikethrough (⌘⇧X)",
    description: "Toolbar strikethrough button on Mac",
  },
  "ui.emailBody.toolbar.strikethrough.win": {
    id: "ui.emailBody.toolbar.strikethrough.win",
    defaultMessage: "Strikethrough (Ctrl+Shift+X)",
    description: "Toolbar strikethrough button on Windows",
  },
  "ui.emailBody.toolbar.textColor": {
    id: "ui.emailBody.toolbar.textColor",
    defaultMessage: "Text color",
    description: "Toolbar text color button",
  },
  "ui.emailBody.toolbar.underline.mac": {
    id: "ui.emailBody.toolbar.underline.mac",
    defaultMessage: "Underline (⌘U)",
    description: "Toolbar underline button on Mac",
  },
  "ui.emailBody.toolbar.underline.win": {
    id: "ui.emailBody.toolbar.underline.win",
    defaultMessage: "Underline (Ctrl+U)",
    description: "Toolbar underline button on Windows",
  },
  "ui.emailBody.toolbar.undo.mac": {
    id: "ui.emailBody.toolbar.undo.mac",
    defaultMessage: "Undo (⌘Z)",
    description: "Toolbar undo button on Mac",
  },
  "ui.emailBody.toolbar.undo.win": {
    id: "ui.emailBody.toolbar.undo.win",
    defaultMessage: "Undo (Ctrl+X)",
    description: "Toolbar undo button on Windows",
  },
  "ui.emailBody.urlFormItem.preview": {
    id: "ui.emailBody.urlFormItem.preview",
    defaultMessage: "Preview",
  },
  "ui.emailBody.urlFormItem.url": {
    id: "ui.emailBody.urlFormItem.url",
    defaultMessage: "URL",
    description: "URL label",
  },
  "ui.emailBody.urlFormItem.validation.urlInvalid": {
    id: "ui.emailBody.urlFormItem.validation.urlInvalid",
    defaultMessage: "Please enter valid URL",
    description: "URL invalid validation message",
  },
  "ui.emailBody.urlFormItem.validation.urlRequired": {
    id: "ui.emailBody.urlFormItem.validation.urlRequired",
    defaultMessage: "Please enter URL",
    description: "URL required validation message",
  },
  "ui.emailDynamicVariableView.someEntitiesMissingData.company": {
    id: "ui.emailDynamicVariableView.someEntitiesMissingData.company",
    defaultMessage: "Some companies are missing data for this variable",
  },
  "ui.emailDynamicVariableView.someEntitiesMissingData.description": {
    id: "ui.emailDynamicVariableView.someEntitiesMissingData.description",
    defaultMessage: "When a variable is missing, it will show up blank.",
  },
  "ui.emailDynamicVariableView.someEntitiesMissingData.ok": {
    id: "ui.emailDynamicVariableView.someEntitiesMissingData.ok",
    defaultMessage: "Okay",
  },
  "ui.emailDynamicVariableView.someEntitiesMissingData.person": {
    id: "ui.emailDynamicVariableView.someEntitiesMissingData.person",
    defaultMessage: "Some people are missing data for this variable",
  },
  "ui.emailRecipientList.waringText.tooltip.duplicate": {
    id: "ui.emailRecipientList.waringText.tooltip.duplicate",
    defaultMessage: "Duplicate email detected",
  },
  "ui.emailRecipientList.waringText.tooltip.duplicate.description": {
    id: "ui.emailRecipientList.waringText.tooltip.duplicate.description",
    defaultMessage:
      "This email already exists in the selection. Remove to avoid sending the same email twice.",
  },
  "ui.emailRecipientList.waringText.tooltip.missingFields": {
    id: "ui.emailRecipientList.waringText.tooltip.missingFields",
    defaultMessage: "Missing dynamic variable",
  },
  "ui.emailRecipientList.waringText.tooltip.missingFields.description": {
    id: "ui.emailRecipientList.waringText.tooltip.missingFields.description",
    defaultMessage:
      "This email doesn’t have a value for at least one dynamic variable that was used.",
  },
  "ui.emailRecipientList.waringText.tooltip.ok": {
    id: "ui.emailRecipientList.waringText.tooltip.ok",
    defaultMessage: "Remove",
  },
  "ui.emailRecipientList.waringText.tooltip.title": {
    id: "ui.emailRecipientList.waringText.tooltip.title",
    defaultMessage: "Issues were detected with this recipient's email:",
  },
  "ui.emailSubject.placeholder": {
    id: "ui.emailSubject.placeholder",
    defaultMessage: "Subject",
    description: "SubjectInput field's placeholder",
  },
  "ui.entityFieldSelector.activity": {
    id: "ui.entityFieldSelector.activity",
    defaultMessage: "Activity",
    description: "Activity",
  },
  "ui.entityFieldSelector.company": {
    id: "ui.entityFieldSelector.company",
    defaultMessage: "Company",
    description: "Company",
  },
  "ui.entityFieldSelector.deal": {
    id: "ui.entityFieldSelector.deal",
    defaultMessage: "Deal",
    description: "Deal",
  },
  "ui.entityFieldSelector.person": {
    id: "ui.entityFieldSelector.person",
    defaultMessage: "Person",
    description: "Person",
  },
  "ui.entityFieldSelector.search.placeholder": {
    id: "ui.entityFieldSelector.search.placeholder",
    defaultMessage: "Search for fields",
    description: "Select for fields placeholder",
  },
  "ui.inlineInput.moreLabel": {
    id: "ui.inlineInput.moreLabel",
    defaultMessage: "+ {count} more",
    description: "More label in inline input",
  },
  "ui.inlineInput.unknown": {
    id: "ui.inlineInput.unknown",
    defaultMessage: "Unknown",
    description: "Inline inputs Unknown value placeholder",
  },
  "ui.input.largeText.textLimitReached": {
    id: "ui.input.largeText.textLimitReached",
    defaultMessage: "Character limit reached",
    description: "Character limit reached text shown below a large text input (LargeTextField)",
  },
  "ui.input.richtext.mentionsDropdown.integrationOnlyTag": {
    id: "ui.input.richtext.mentionsDropdown.integrationOnlyTag",
    defaultMessage: "{crm} only",
    description:
      "Tag next to a user in the @mention list who cannot sign in and is reached only in the org's CRM; {crm} is the CRM's brand name, e.g. HubSpot",
  },
  "ui.input.richtext.mentionsDropdown.noResult": {
    id: "ui.input.richtext.mentionsDropdown.noResult",
    defaultMessage: "No results",
    description: "text Area With Mentions - No results",
  },
  "ui.manualAddress.city": {
    id: "ui.manualAddress.city",
    defaultMessage: "City",
    description: "City address field",
  },
  "ui.manualAddress.country": {
    id: "ui.manualAddress.country",
    defaultMessage: "Country",
    description: "Country address field",
  },
  "ui.manualAddress.postalCode": {
    id: "ui.manualAddress.postalCode",
    defaultMessage: "Postal Code",
    description: "Postal code address field",
  },
  "ui.manualAddress.regionProvince": {
    id: "ui.manualAddress.regionProvince",
    defaultMessage: "State/Province",
    description: "State/Province field on the Create Company modal",
  },
  "ui.manualAddress.saveAllFields": {
    id: "ui.manualAddress.saveAllFields",
    defaultMessage: "Save all address fields",
    description: "Save all fields",
  },
  "ui.manualAddress.searchGoogle": {
    id: "ui.manualAddress.searchGoogle",
    defaultMessage: "Search Addresses via Google",
    description: "Search with Google button for auto-complete address field",
  },
  "ui.manualAddress.street": {
    id: "ui.manualAddress.street",
    defaultMessage: "Street",
    description: "Street Address field",
  },
  "ui.modal.close.tooltip": {
    id: "ui.modal.close.tooltip",
    defaultMessage: "Close",
    description: "Close tooltip",
  },
  "ui.modal.collapse.tooltip": {
    id: "ui.modal.collapse.tooltip",
    defaultMessage: "Exit full screen",
    description: "Collapse tooltip",
  },
  "ui.modal.expand.tooltip": {
    id: "ui.modal.expand.tooltip",
    defaultMessage: "Go full screen",
    description: "Expand tooltip",
  },
  "ui.modal.footer.cancelText": {
    id: "ui.modal.footer.cancelText",
    defaultMessage: "Cancel",
    description: "Modal Cancel button Text",
  },
  "ui.modal.footer.okText": {
    id: "ui.modal.footer.okText",
    defaultMessage: "Okay",
    description: "Modal Okay button Text",
  },
  "ui.modal.minimize.disabledTooltip": {
    id: "ui.modal.minimize.disabledTooltip",
    defaultMessage: "Only one form can be minimized at a time",
    description: "Collapse disabled tooltip",
  },
  "ui.modal.minimize.tooltip": {
    id: "ui.modal.minimize.tooltip",
    defaultMessage: "Minimize",
    description: "Minimize tooltip",
  },
  "ui.popconfirm.footer.cancelText": {
    id: "ui.popconfirm.footer.cancelText",
    defaultMessage: "Cancel",
    description: "Popconfirm Cancel button Text",
  },
  "ui.popconfirm.footer.okText": {
    id: "ui.popconfirm.footer.okText",
    defaultMessage: "OK",
    description: "Popconfirm Okay button Text",
  },
  "ui.popconfirm.title": {
    id: "ui.popconfirm.title",
    defaultMessage: "Are you sure?",
    description: "Popconfirm default title Text",
  },
  "ui.selectField.placeholder": {
    id: "ui.selectField.placeholder",
    defaultMessage: "Select",
    description: "Select field placeholder",
  },
  "ui.teamMultiSelect.placeholder": {
    id: "ui.teamMultiSelect.placeholder",
    defaultMessage: "Click or type to select teams",
    description: "Placeholder displayed in a TeamMultiSelectField component",
  },
  "ui.teamPicker.deselectAll": {
    id: "ui.teamPicker.deselectAll",
    defaultMessage: "Deselect All",
    description: "Deselect all teams button",
  },
  "ui.teamPicker.search.placeholder": {
    id: "ui.teamPicker.search.placeholder",
    defaultMessage: "Search teams",
    description: "Search teams placeholder",
  },
  "ui.teamPicker.selectAll": {
    id: "ui.teamPicker.selectAll",
    defaultMessage: "Select All",
    description: "Select all teams button",
  },
  "ui.textField.error.limit": {
    id: "ui.textField.error.limit",
    defaultMessage: "Character limit reached",
    description: "Character limit reached text on text input",
  },
  "ui.userPicker.deselectAll": {
    id: "ui.userPicker.deselectAll",
    defaultMessage: "Deselect All",
    description: "Deselect all users button",
  },
  "ui.userPicker.search.placeholder": {
    id: "ui.userPicker.search.placeholder",
    defaultMessage: "Search users",
    description: "Search users placeholder",
  },
  "ui.userPicker.selectAll": {
    id: "ui.userPicker.selectAll",
    defaultMessage: "Select All",
    description: "Select all users button",
  },
  "ui.visibilitySelector.done": {
    id: "ui.visibilitySelector.done",
    defaultMessage: "Done",
    description: "Done button for team select",
  },
  "ui.visibilitySelector.entireOrg": {
    id: "ui.visibilitySelector.entireOrg",
    defaultMessage: "Entire org",
    description: "Entire org option",
  },
  "ui.visibilitySelector.myTeam": {
    id: "ui.visibilitySelector.myTeam",
    defaultMessage: "My team",
    description: "My team option",
  },
  "ui.visibilitySelector.onlyMe": {
    id: "ui.visibilitySelector.onlyMe",
    defaultMessage: "Only me",
    description: "Only me option",
  },
  "ui.visibilitySelector.search.placeholder": {
    id: "ui.visibilitySelector.search.placeholder",
    defaultMessage: "Search for teams",
    description: "Search for teams placeholdef",
  },
  "ui.visibilitySelector.specificTeams": {
    id: "ui.visibilitySelector.specificTeams",
    defaultMessage: "Specific teams",
    description: "Specific teams option",
  },
});

export default messages;
